import React from "react";
import classNames from "classnames";
import { CheckIcon } from "@/assets/icons";
import { DashboardReferralI } from "@/types/referals";
import cls from "./styles.module.scss";

export const GOAL_ORDERS = 30;
// цель 5 заказов на шкале из 30
export const GOAL5_POSITION = (5 / GOAL_ORDERS) * 100;
export const REFERRAL_WINDOW_DAYS = 28;

// всё, что нужно шкале: и строка списка, и карточка водителя подходят
export type GoalProgress = Pick<
  DashboardReferralI,
  "deadline" | "orders_in_window" | "orders_5" | "orders_30"
>;

export const isWindowExpired = (referral: Pick<GoalProgress, "deadline">) =>
  new Date().getTime() > new Date(referral.deadline).getTime();

export const GoalRail = ({ referral }: { referral: GoalProgress }) => {
  const isExpired = isWindowExpired(referral);

  const progress = Math.min(referral.orders_in_window / GOAL_ORDERS, 1) * 100;
  // бегунок не рисуем, когда он совпадает с закрытой целью
  const hideCurrent =
    referral.orders_30.completed ||
    (referral.orders_5.completed && Math.abs(progress - GOAL5_POSITION) < 2);

  return (
    <div className={cls.rail}>
      <div className={cls.railBar}>
        <div
          className={classNames(cls.railDone, isExpired && cls.railDead)}
          style={{ width: `${progress}%` }}
        />
        <div
          className={classNames(
            cls.railNode,
            referral.orders_5.completed && cls.railHit
          )}
          style={{ left: `${GOAL5_POSITION}%` }}
        >
          {referral.orders_5.completed && (
            <CheckIcon size={9} strokeWidth={4.5} />
          )}
        </div>
        <div
          className={classNames(
            cls.railNode,
            referral.orders_30.completed && cls.railHit
          )}
          style={{ left: "100%" }}
        >
          {referral.orders_30.completed && (
            <CheckIcon size={9} strokeWidth={4.5} />
          )}
        </div>
        {!hideCurrent && (
          <div
            className={classNames(cls.railNow, isExpired && cls.railDead)}
            style={{ left: `${Math.max(progress, 2.5)}%` }}
          />
        )}
      </div>
      <div className={cls.railTicks}>
        <span style={{ left: `${GOAL5_POSITION}%` }}>5</span>
        <span className={cls.railTickEnd}>{GOAL_ORDERS}</span>
      </div>
    </div>
  );
};
